import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useUser } from "../contexts/UserContext";

const ProtectedRoute: React.FC = () => {
  const { userDetails, authLoading } = useUser()!;

  if (authLoading) {
    return null;
  }

  if (!userDetails?.user) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
